export const referencesData = [
    {
        type: "Kellerentrümpelung",
        location: "Berlin Friedrichshian",
        image_before: "/images/kel-before.jpg",
        image_after: "/images/kel-after.png"
    },
    {
        type: "Sperrmüll Abholung",
        location: "Berlin Steglitz-Zehlendorf",
        image_before: "/images/spermul-before.jpg",
        image_after: "/images/spermul-after.jpg"
    },
    {
        type: "Messie-Wohnung entrümpeln",
        location: "Berlin Marzahn",
        image_before: "/images/messy-room-before.jpg",
        image_after: "/images/messy-room-after.jpg"
    },
    {
        type: "Courierdienst",
        location: "Berlin Brandenburg",
        image_before: "/images/courier-before.jpg",
        image_after: "/images/courier-after.jpg"
    }
];